//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  props: {
    value: {    //文本框内容
      type: String,
      default: ''
    },
    iconSrc: { // 文本框右侧icon
      type: String,
      default: ''
    },
    baseFrame: { //默认文本框 样式
      type: Boolean,
      default: false,
    },
    indexFrame: { // 首页文本框样式
      type: Boolean,
      default: false,
    },
    answerFrame: { // 答题页文本框样式
      type: Boolean,
      default: false,
    }
  },
  computed: {
    length() {
      return (this.value.length - 30 ) > 0
    }
  },
}
